module.exports = __webpack_public_path__ + "static/media/sixsense-gallery-4.38d64871.jpg";